import React from "react";
import "./index.css";
import { motion } from "framer-motion";
import { adds } from "../../../assets";

const Medios = ({ variants }) => {
  return (
    <div className="mediosDiv flex flexCol gap">
      <img className="blur blur2" src={adds.blur1} alt="Blur" />

      <motion.div
        variants={variants}
        initial={"initial"}
        whileInView={"ani"}
        viewport={{ once: true }}
        custom={0.3}
        className="flex flexCol"
      >
        <h4>Address</h4>
        <p>Argentina, San Luis 1632</p>
      </motion.div>
    </div>
  );
};

export default Medios;
